// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout__root--hXdm-"};